import React from "react";
import Typography from "@mui/material/Typography";
import { calcPackageCountPerDeal } from "../utils/deal";
import { useRecordContext } from "react-admin";

type Props = {
  source?: string;
  label?: string;
  sortable?: false;
};

export const PackageCountPerDealField: React.FC<Props> = () => {
  const record = useRecordContext();
  const packaging_form = record?.packaging_form;
  if (!record || !packaging_form) {
    return null;
  }
  const { amount_in_kg, deal_amount } = packaging_form;
  const packageCount = calcPackageCountPerDeal(amount_in_kg, deal_amount);
  return <Typography variant="body2">{packageCount.toString()}</Typography>;
};
